import { useCallback, useState } from "react";

export type OpenEntity = {
  uuid: string | undefined;
  list?: string[];
};

export function useEntityPreview() {
  const [preview, open] = useState<OpenEntity | undefined>();
  const close = useCallback(() => open(undefined), []);
  return { uuid: preview?.uuid, list: preview?.list, open, close };
}
